import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconOpenInFigma({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.756 20.032c1.521 0 2.756-1.197 2.756-2.672v-2.672H7.756C6.235 14.688 5 15.885 5 17.36s1.235 2.672 2.756 2.672z" fill="#0ACF83"/>
            <path d="M5 12.016c0-1.475 1.235-2.672 2.757-2.672h2.756v5.344H7.756C6.235 14.688 5 13.49 5 12.016z" fill="#A259FF"/>
            <path d="M5.001 6.672C5.001 5.197 6.235 4 7.756 4h2.757v5.344H7.756c-1.52 0-2.755-1.197-2.755-2.672z" fill="#F24E1E"/>
            <path d="M10.512 4h2.756c1.522 0 2.756 1.197 2.756 2.672s-1.234 2.673-2.756 2.673h-2.756V4z" fill="#FF7262"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.024 12.016c0-1.475-1.234-2.672-2.756-2.672-1.52 0-2.756 1.197-2.756 2.672 0 1.302.96 2.387 2.232 2.624a1.87 1.87 0 0 1 1.71-2.624h1.57zm-.216 1.037h-1.354a.833.833 0 0 0-.443 1.537 2.74 2.74 0 0 0 1.798-1.537z" fill="#1ABCFE"/>
            <path d="M12.294 20.756a.833.833 0 0 0 1.179 0l4.862-4.86v2.7a.833.833 0 0 0 1.665 0v-4.71a.833.833 0 0 0-.833-.833h-4.713a.833.833 0 1 0 0 1.664h2.703l-4.863 4.861a.833.833 0 0 0 0 1.178z" fill={fill}/>
        </svg>
    );
}

export default IconOpenInFigma;
